import React from 'react';
import { useStyletron } from 'baseui';

const Ellipsis = ({ fill }: { fill?: string }) => {
	const [css, theme]: [any, any] = useStyletron();
	if (!fill) {
		fill = theme.colors.primaryA;
	}

	return (
		<svg width='16' height='8' viewBox='0 0 16 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M13.6 1H2.4C1.6268 1 1 1.6268 1 2.4V5.2C1 5.9732 1.6268 6.6 2.4 6.6H13.6C14.3732 6.6 15 5.9732 15 5.2V2.4C15 1.6268 14.3732 1 13.6 1Z'
				stroke={fill}
				strokeWidth='1.4'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M4.7998 3.79993H4.8078'
				stroke={fill}
				strokeWidth='1.4'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path d='M8 3.79993H8.008' stroke={fill} strokeWidth='1.4' strokeLinecap='round' strokeLinejoin='round' />
			<path
				d='M11.2002 3.79993H11.2082'
				stroke={fill}
				strokeWidth='1.4'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default React.memo(Ellipsis);
